export default __webpack_public_path__ + "static/media/Idara Suit -  Data School Support Person.7e99e443.png";